import {
  Accordion,
  Box,
  Flex,
  Image,
  Step,
  StepDescription,
  StepIndicator,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  Text,
  Textarea,
} from "@chakra-ui/react";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { AddHOPICall, FetchHistoryOfPresentIllness } from "../../middleware/services/messages";
import moment from "moment";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import GrayCard from "../../components/card";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import { useForm } from "react-hook-form";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home";
import { getIsDoctor, getLoginID } from "../../auth";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager";
import { CorrectChiefComplaintUsingAI, CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
import DynamicModal from "../../components/dynamic-modal";
import DatePicker from "../../components/date-picker";
import { format } from "date-fns";
import { GetDoctorMasterData } from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import { formatHPIMasterData } from "../../middleware/domains/visits/doctornotes";
import HpiNotesCard from "../../components/patient-health/doctor-notes/hpi-notes-card";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";

const HistoryOfPresentIllness = ({ id, backFunction }) => {
  const location = useLocation();
  const [patientid, setPatientid] = useState("");
  const [apmtIdUrl, setApmtIdUrl] = useState("");
  const [historyIllnessData, setHistoryIllnessData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const navigate = useNavigate();

  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split("?")[1]);
    const id = searchParams.get("id");
    const apmtid = searchParams.get('appointmentid');
    setPatientid(id);
    // setApmtIdUrl(apmtid);

    if (apmtid) {
    setApmtIdUrl(apmtid);
  }

  if(apmtid) {
      fetchhistoryillnessdata(id, apmtid)
      fetchHPIMasterData();
    } else {
      fetchhistoryillnessdata(id, "")
    }

    // fetchhistoryillnessdata(id);
  }, []);

  const fetchhistoryillnessdata = async (id, apmtid="") => {
    showLoader();
    try {
      const result = await FetchHistoryOfPresentIllness({
        patientid: id,
        ...(apmtid && { appointmentid: apmtid }), 
        ...(apmtid && { type: 'ipd' })
      });

      if (result != null) {
        console.log(result);
        setHistoryIllnessData(result);
      } else {
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in home:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };

  // console.log(patientid, "historyIllness IDDDDD")
  // console.log(historyIllnessData, "historyIllness Dataaaaaaa")

  function parseDateString(dateString) {
    const dateParts = dateString.replace(/[\.,]/g, "").split(" ");
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0]);
      const month = dateParts[1];
      const year = parseInt(dateParts[2]);

      const monthIndex = new Date(`${month} 1, ${year}`).getMonth() + 1;
      const formattedDate = `${year}-${
        monthIndex < 10 ? "0" + monthIndex : monthIndex
      }-${day < 10 ? "0" + day : day}`;
      return formattedDate;
    }
    return dateString;
  }

  function calculateAge(dateOfBirth) {
    const parsedDate = parseDateString(dateOfBirth);
    const today = new Date();
    const dob = new Date(parsedDate);

    if (isNaN(dob)) {
      console.error("Invalid date format:", parsedDate);
      return NaN;
    }

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }

  const generateDynamicText = (item, gender, dob) => {
    let outputTexts = [];
    if(item.details == null){
      return false;
    }
    // Retrieve stored data from localStorage
    let storedData = localStorage.getItem("dobAndGenderData");
    let parsedData = storedData ? JSON.parse(storedData) : {};
    let genderFromStorage = parsedData.gender || "";
    let dobFromStorage = parsedData.dob || "";

    // Use provided gender and dob or fallback to localStorage data
    let genderToUse = gender || genderFromStorage;
    let dobToUse = dob || dobFromStorage;
    let age = calculateAge(dobToUse);

    let attributes = {};
    if (item.details && Array.isArray(item.details) && item.details.length < 0) {
      return;
    }
    // Parse the item details to extract attributes
    if (item.details && Array.isArray(item.details)) {
      item.details.forEach((attribute) => {
        switch (attribute.attribute) {
          case "Site":
            attributes.site = attribute.values.map((v) => v.value).join(", ");
            break;
          case "Onset":
            attributes.onset = attribute.value;
            break;
          case "Chronicity":
            attributes.chronicity = attribute.value;
            break;
          case "Onset Quality":
            attributes.onsetQuality = attribute.value;
            break;
          case "Frequency":
            attributes.frequency = attribute.value;
            break;
          case "Associated Symptoms":
            attributes.symptoms = attribute.values
              .map((v) => v.value)
              .join(", ");
            break;
          case "Rating Scale":
            attributes.ratingScale = attribute.value;
            break;
          case "Time":
            attributes.time = attribute.value;
            break;
          case "Time Value":
            attributes.timeValue = attribute.value;
            break;
          default:
            break;
        }
      });
    }

    // Generate the patient introductory text
    let patientText = `The patient is a ${
      isNaN(age) ? "" : age
    }-year-old individual (${genderToUse}) `;
    let template = `${patientText}`;

    // Add each attribute's sentence only if the data is available
    if (attributes.site) {
      template += `presenting with ${attributes.site} ${item.type}. `;
    }

    if (attributes.onset) {
      template += `The ${item.type} started ${attributes.onset} and `;
      if (attributes.chronicity) {
        template += `is described as ${attributes.chronicity} in nature. `;
      }
    }

    if (attributes.onsetQuality) {
      template += `The onset of the ${item.type} was ${attributes.onsetQuality}. `;
    }

    if (attributes.frequency) {
      template += `The ${item.type} is ${attributes.frequency} and `;
    }

    if (attributes.ratingScale) {
      template += `is rated as ${attributes.ratingScale} out of 10 in intensity. `;
    }

    if (attributes.symptoms) {
      template += `Associated with ${attributes.symptoms}.`;
    }

    // Push the generated template to the outputTexts array
    outputTexts.push(template.trim());

    return outputTexts;
  };

  const groupByBookingId = (data) => {
  if (!Array.isArray(data)) return [];

  // For "other" type, don't group at all - return each item individually
  const otherTypeItems = data.filter(item => item.type === "other").map(item => ({
    ...item,
    // summaries: new Set([item.summary.trim()]), // Convert summary to Set for consistency
    summaries: new Set([item.summary]), // Convert summary to Set for consistency
    details: [] // Empty details array to maintain structure
  }));

  // For non-"other" types, maintain original grouping by bookingid
  const nonOtherItems = data.filter(item => item.type !== "other");
  const groupedNonOther = nonOtherItems.reduce((acc, item) => {
    if (!acc[item.bookingid]) {
      acc[item.bookingid] = {
        ...item,
        doctorname: item.doctorname,
        bookingid: item.bookingid,
        appointmentid: item.appointmentid,
        specialization: item.specialization,
        appointmentdate: item.appointmentdate,
        details: [],
        summaries: new Set(),
        iscurrentvisit: item.iscurrentvisit,
        type: item.type,
        profilepictureurl: item.profilepictureurl
      };
    }

    if (item.details || (!item.details && !item.summary)) {
      acc[item.bookingid].details.push(item);
    }

    return acc;
  }, {});

  // Combine both - other type items first, then grouped non-other items
  return [
    ...otherTypeItems,
    ...Object.values(groupedNonOther).map(group => ({
      ...group,
      summary: group.details[0]?.summary
    }))
  ];
};

//   const groupByBookingId = (data) => {
//   if (!Array.isArray(data)) {
//     return [];
//   }

//   const grouped = data.reduce((acc, item) => {
//     if (!acc[item.bookingid]) {
//       acc[item.bookingid] = {
//         doctorname: item.doctorname,
//         bookingid: item.bookingid,
//         specialization: item.specialization,
//         appointmentdate: item.appointmentdate,
//         details: [],
//         summary: item.summary, // Ensure summary is preserved
//         iscurrentvisit: item.iscurrentvisit,
//         updatedby: item.updatedby,
//         updateddate: item.updateddate,
//         appointmentid: item.appointmentid,
//         id: item.id
//       };
//     }
    
//     // Only push to details if it's a detail item (not summary-only)
//     if (item.details || (!item.details && !item.summary)) {
//       acc[item.bookingid].details.push(item);
//     }
    
//     // Update summary if current item has one
//     if (item.summary) {
//       acc[item.bookingid].summary = item.summary;
//     }
    
//     return acc;
//   }, {});

//   return Object.values(grouped);
// };

  // const groupByBookingId = (data) => {
  //   if (!Array.isArray(data)) {
  //     return [];
  //   }

  //   const grouped = data.reduce((acc, item) => {
  //     if (!acc[item.bookingid]) {
  //       acc[item.bookingid] = {
  //         doctorname: item.doctorname,
  //         bookingid: item.bookingid,
  //         specialization: item.specialization,
  //         appointmentdate: item.appointmentdate,
  //         details: [],
  //         summary: item.summary,
  //         iscurrentvisit: item.iscurrentvisit,
  //       };
  //     }
  //     acc[item.bookingid].details.push(item);
  //     return acc;
  //   }, {});

  //   return Object.values(grouped);
  // };
  const groupedData = groupByBookingId(historyIllnessData);

// ---------------------------- Add & Edit Functionality-----------------------------------------
const addHPI = React.useRef();
const editHPI = React.useRef();
var [DoctorListForDropdown, setDoctorListForDropdown] = useState([]);
var [DoctorList, setDoctorList] = useState([]);
var [Doctorid, setDoctorid] = useState(null);
var [DefaultDoctor, setDefaultDoctor] = useState(null);
const [addHPIText, setAddHPIText] = useState('')
const [editHPIText, setEditHPIText] = useState('')

  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [initialText, setInitialText] = useState("");

    const [addDate, setAddDate] = useState(null);
    const [addDocId, setAddDocId] = useState(null);
    

const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
const [time, setTime] = useState(moment().format("HH:mm"));

const getLocalISOString = (dateStr, timeStr) => {
  // Parse the date in DD-MM-yyyy format
  const [day, month, year] = dateStr.split("-").map(Number);
  // Parse the time in HH:mm format
  const [hours, minutes] = timeStr.split(":").map(Number);
  
  // Create a Date object in local timezone
  const dateObj = new Date(year, month - 1, day, hours, minutes, 0);
  
  // Format to ISO string with local timezone offset
  const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
  const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');
  
  return localISOTime;
};

const handledatechange = (selectedDate) => {
  const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
  setDate(formattedDate);
};

const handleTimeChange = (event) => {
  const inputTime = event.target.value;
  const currentDate = moment().format("DD-MM-yyyy");
  const currentTime = moment().format("HH:mm");
  
  // Only validate if the selected date is today
  if (date === currentDate) {
    const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
    const [currentHours, currentMinutes] = currentTime.split(":").map(Number);

    // Create moment objects for comparison
    const inputMoment = moment().set({
      hour: inputHours,
      minute: inputMinutes,
      second: 0,
      millisecond: 0
    });
    
    const currentMoment = moment();

    if (inputMoment.isAfter(currentMoment)) {
      setTime(currentTime);
      showErrorToast("Future time cannot be selected.");
      return;
    }
  }
  
  // If date is not today or time is not in future, update the time
  setTime(inputTime);
};

const handleEditTimeChange = (event) => {
  const inputTime = event.target.value;
  const currentDate = moment().format("DD-MM-yyyy");
  const currentTime = moment().format("HH:mm");
  
  // Only validate if the selected date in edit modal is today
  if (editHPIData.date === currentDate) {
    const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
    const [currentHours, currentMinutes] = currentTime.split(":").map(Number);

    // Create moment objects for comparison
    const inputMoment = moment().set({
      hour: inputHours,
      minute: inputMinutes,
      second: 0,
      millisecond: 0
    });
    
    const currentMoment = moment();

    if (inputMoment.isAfter(currentMoment)) {
      const currentFormattedTime = moment().format("HH:mm");
      setEditHPIData(prev => ({...prev, time: currentFormattedTime}));
      showErrorToast("Future time cannot be selected.");
      return;
    }
  }
  
  // If date is not today or time is not in future, update the time
  setEditHPIData(prev => ({...prev, time: inputTime}));
};

// existing functions
// const handleTimeChange = (event) => {
//   const inputTime = event.target.value;
//   const currentTime = new Date();
//   const [inputHours, inputMinutes] = inputTime.split(":").map(Number);

//   const inputDate = new Date();
//   inputDate.setHours(inputHours);
//   inputDate.setMinutes(inputMinutes);

//   if (inputDate > currentTime) {
//     const currentFormattedTime = moment().format("HH:mm");
//     setTime(currentFormattedTime);
//     showErrorToast("Future time cannot be selected.");
//   } else {
//     setTime(inputTime);
//   }
// };
// const handleEditTimeChange = (event) => {
//     const inputTime = event.target.value;
//     const currentTime = new Date();
//     const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
  
//     const inputDate = new Date();
//     inputDate.setHours(inputHours);
//     inputDate.setMinutes(inputMinutes);
  
//     if (inputDate > currentTime) {
//       const currentFormattedTime = moment().format("HH:mm");
//       setEditHPIData(prev => ({...prev, time: currentFormattedTime}));
//       showErrorToast("Future time cannot be selected.");
//     } else {
//       setEditHPIData(prev => ({...prev, time: inputTime}));
//     }
//   };

const addHPIData = () => {
  // Clear the instructions properly
  // setInstructions("");
  setPlaceholder("Click anywhere to start typing....")
  setValue("textField", ""); // Clear the form value
  setAddHPIText('')
  setDate(moment().format("DD-MM-yyyy"));
  setTime(moment().format("HH:mm"));
  fetchDoctors();
  addHPI.current.openModal();
  // setShowDocNamesDropdown(false)
} 

// const openEditHPIModal = (item) => {
//   console.log('item: ', item)
//   setPlaceholder("Click anywhere to start typing....")
//   setValue("textField", ""); // Clear the form value
//   setAddHPIText('')
//   setDate(moment().format("DD-MM-yyyy"));
//   setTime(moment().format("HH:mm"));
//   fetchDoctors();
//   editHPI.current.openModal();
//   // setShowDocNamesDropdown(false)
// } 

// Function to extract comma-separated specialties from doctorspeciality array
const getCommaSeparatedSpecialties = (specialtiesArray) => {
  if (!specialtiesArray || !Array.isArray(specialtiesArray)) {
    return "";
  }
  
  // Extract specialityname from each object and filter out null/undefined values
  const specialtyNames = specialtiesArray
    .map(specialty => {
      if (specialty?.specialityname === "Other" && specialty?.othervalue) {
        // Use othervalue when specialityname is "Other" and othervalue exists
        return specialty.othervalue;
      } else {
        // Use specialityname for all other cases
        return specialty?.specialityname;
      }
    })
    .filter(name => name != null && name.trim() !== "");
  
  return specialtyNames.join(", ");
};

const [doctorSpecialties, setDoctorSpecialties] = useState("");
// Updated fetchDoctors function with specialty handling
const fetchDoctors = async () => {
  showLoader();
  try {
    const result = await FetchUsersByClinic({
      appointmentid: apmtIdUrl,
    });

    if (result.output.result == "success") {
      console.log('result.output.data: ', result.output.data);
      
      // Process doctors with specialties
      const processedDoctors = result.output.data.map(doctor => ({
        ...doctor,
        specialtiesString: getCommaSeparatedSpecialties(doctor.doctorspeciality)
      }));
      
      setDoctorList(processedDoctors);
      
      const Doctors = processedDoctors.map((doctor) => [
        doctor.fullname
      ]);
      console.log('Doctors: ', Doctors);
      setDoctorListForDropdown(Doctors);
      
      const currentdoctor = getIsDoctor();
      console.log('currentdoctor: ', currentdoctor);
      const loginid = getLoginID();
      console.log('getLogin: ', loginid);
      
      let obj = {};
      if (currentdoctor == 1 && currentdoctor != null) {
        obj = processedDoctors.filter(doctor => doctor.doctorid == loginid);
        if (obj[0]) {
          console.log('obj[0]: ', obj[0].fullname);
          setDefaultDoctor(obj[0].fullname);
          setDoctorid(loginid);
          // Set specialties for the current doctor
          setDoctorSpecialties(obj[0].specialtiesString);
        }
      } else {
        setDefaultDoctor("");
        // Reset specialties if no current doctor
        setDoctorSpecialties("");
      }
    } else {
      setDoctorList([]);
      dismissLoader();
    }
    dismissLoader();
  } catch (error) {
    console.error("Error", error);
  }
};

// const fetchDoctors = async () => {
//     showLoader();
//     try {
//       // const result = await FetchDoctorsByUser({
//       const result = await FetchUsersByClinic({
//         // doctorid,
//         appointmentid: apmtIdUrl,
//       });

//       // console.log('resultofDoctors: ', result)
//       if (result.output.result == "success") {
//         console.log('result.outptu.data: ', result.output.data)
//         setDoctorList(result.output.data);
//         const Doctors = result.output.data && result.output.data.map((step) => [
//           step.fullname
//         ]);
//         console.log('Doctors: ', Doctors)
//         setDoctorListForDropdown(Doctors);
//         const currentdoctor = getIsDoctor();
//         console.log('currentdoctor: ', currentdoctor)
//         const loginid = getLoginID();
//         console.log('getLogin: ', loginid)
        
//         let obj = {}
//         if (currentdoctor == 1 && currentdoctor != null) {
//           obj = result.output.data && result.output.data.filter(doctor => doctor.doctorid == loginid);
//           if (obj[0]) {
//             console.log('obj[0]: ', obj[0].fullname)
//             setDefaultDoctor(obj[0].fullname)
//             setDoctorid(loginid)
//           }

//         } else {
//           setDefaultDoctor("");
//         }
//       } else {
//         setDoctorList([]);
//         dismissLoader();
//       }
//       dismissLoader();
//     } catch (error) {
//       console.error("Error", error);
//     }
//   };

const HandleAddDoctor = (selectedOption) => {
    let obj = DoctorList.filter(doctor => doctor.fullname == selectedOption);
    // setDoctorid(obj[0].doctorid)
    if (obj.length > 0) {
    setDoctorid(obj[0].doctorid);
    // setSelectedDoctorId(obj[0].doctorid); // Store the selected doctor ID
    setDefaultDoctor(obj[0].fullname);
    setDoctorSpecialties(obj[0].specialtiesString);
  }
  }

// Also update your HandleEditDoctor to update editHPIData
const HandleEditDoctor = (selectedOption) => {
  let obj = DoctorList.filter(doctor => doctor.fullname == selectedOption);
  if (obj.length > 0) {
    // setDoctorid(obj[0].doctorid);
    // setDefaultDoctor(obj[0].fullname);
    
    // Also update the editHPIData with the new doctor info
    setEditHPIData(prev => ({
      ...prev,
      doctorid: obj[0].doctorid,
      doctorname: obj[0].fullname,
      doctorspecialties: obj[0].specialtiesString
    }));
    // Also update the global doctorSpecialties state
    setDoctorSpecialties(obj[0].specialtiesString);
  }
};

  //Remove speech and keep Null to toggle between GPU and Speech
  const { transcriber: activeTranscriber, mode } =
    useHybridTranscriber("speech", (text) => {
      // called when speech recognition finishes
      setPlaceholder(text || "");
      setTyping(false);
  });
  
  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [placeholder, setPlaceholder] = useState(
    "Click anywhere to start typing...."
  );

  useEffect(() => {
    if (activeTranscriber?.output?.text) {
  const transcribedText = activeTranscriber.output.text;
  setValue("textField", transcribedText);
  // setAddGeneralDoctorNotes(transcribedText); // Update the state with transcribed text
  // setPlaceholder("Click anywhere to start typing...."); // Clear the placeholder when text exists
  setAddHPIText(transcribedText); // Add this line to update addHPIText state
    setPlaceholder("");
  setTyping(false);
}
    }, [activeTranscriber?.output]);

    // Handle text changes in the textarea
const handleTextChange = (e) => {
  const text = e.target.value;
  setAddHPIText(text);
  setValue("textField", text); // Keep form value in sync
  setPlaceholder(text ? "" : "Click anywhere to start typing...."); // Show placeholder only when empty
};
const handleEditTextChange = (e) => {
    const text = e.target.value;
    setEditHPIText(text);
    setValue("textField", text); // Keep form value in sync
    setPlaceholder(text ? "" : "Click anywhere to start typing...."); // Show placeholder only when empty
  };

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
      // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

    const correctOrders = async (formType) => {
        const currentText = watch("textField");
        
        if (!currentText) {
          showErrorToast("No text available to correct");
          return;
        }
    
        // const inputToSave = {
        //   input: {
        //     text: currentText,
        //   },
        // };
        console.log('doctorSpecilaityes: ', doctorSpecialties)
        const inputToSave = {
          input: {
            text: currentText,
            // type: `hpi#${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
            type: "HPI"
          },
        };
    
        showLoader();
        try {
          // const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
          const result = await CorrectMedicalTermsUsingAI(inputToSave);
          if (result) {
            showSuccessToast("Updated Text");
            const updatedText = result?.text;
    
            // Update form value
            setValue("textField", updatedText, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            });
    
    console.log('updatedText: ', updatedText)
            
            // Update the appropriate state based on form type
            if (formType === "add") {
              setAddHPIText(updatedText);
            } else {
              // handleEditMedicineChange("custommessage", updatedText);
              setEditHPIText(updatedText);
            }
            
            setPlaceholder("");
            setIsButtonDisabled(false);
          }
        } catch (error) {
          console.error("Error in Correct AI call:", error);
          // showErrorToast("Error Happened While Correcting.");
          showErrorToast("Error in Correct AI call.");
        } finally {
          dismissLoader();
        }
    };

  const handleHPISubmission = async () => {
  if (!Doctorid) {
    showErrorToast("Please select a doctor");
    return;
  }

  if (!addHPIText || addHPIText.trim() === "") {
    showErrorToast("Please enter HPI text");
    return;
  }

  const inputToSave = {
    input: {
      appointmentid: apmtIdUrl, 
      patientid: patientid,
      updatedby: Doctorid,
      updateddate: getLocalISOString(date, time),
      hpitext: [
        {
          type: "other", 
          description: addHPIText,
          id: null,
          updatedby: Doctorid,
          updateddate: getLocalISOString(date, time)
        }
      ]
    }
  };

  showLoader();
  try {
    const result = await AddHOPICall(inputToSave.input); 
    if (result.output.result === "success") {
      // fetchhistoryillnessdata(patientid)
      if(apmtIdUrl) {
        fetchhistoryillnessdata(patientid, apmtIdUrl)
      }else {
        fetchhistoryillnessdata(patientid)

      }
      showSuccessToast("HPI added successfully");
      addHPI.current.closeModal();
// if(operation == 'add') {
//   addHPI.current.closeModal();
// }else {
//   editHPI.current.closeModal();
// }
    }
  } catch (error) {
    console.error("Error adding HPI:", error);
    showErrorToast("Error adding HPI");
  } finally {
    dismissLoader();
  }
};

// Edit functionality 
const [editHPIData, setEditHPIData] = useState({
  id: null,
  summary: '',
  date: moment().format("DD-MM-yyyy"),
  time: moment().format("HH:mm"),
  doctorid: null,
  doctorname: ''
});

const openEditHPIModal = (item) => {
  console.log('item: ', item);
  
  // Parse the date from the item
  const itemDate = moment(item.updateddate || item.appointmentdate).format("DD-MM-yyyy");
  const itemTime = moment(item.updateddate || item.appointmentdate).format("HH:mm");

  setEditHPIData({
    id: item.id,
    summary: item.summary,
    date: itemDate,
    time: itemTime,
    doctorid: item.doctorid,
    doctorname: item.doctorname
  });

  setValue("textField", item.summary || "");
  setEditHPIText(item.summary || "");
  setPlaceholder(item.summary ? "" : "Click anywhere to start typing....");

  // Set the doctor values from the item, NOT from fetchDoctors
  setDefaultDoctor(item.doctorname);
  setDoctorid(item.doctorid);

  // fetchDoctors();
  // Only fetch doctors if the list is empty, but don't let it override the current selection
  if (!DoctorListForDropdown || DoctorListForDropdown.length === 0) {
    fetchDoctorsWithoutSettingDefault();
  }
  
  editHPI.current.openModal();
};

// Create a new function that fetches doctors without setting default values
const fetchDoctorsWithoutSettingDefault = async () => {
  showLoader();
  try {
    const result = await FetchDoctorsByUser({});

    if (result.output.result == "success") {
      setDoctorList(result.output.data);
      const Doctors = result.output.data && result.output.data.map((step) => [
        step.fullname
      ]);
      setDoctorListForDropdown(Doctors);
      // DON'T set default doctor or doctorid here
    }
    dismissLoader();
  } catch (error) {
    console.error("Error", error);
    dismissLoader();
  }
};

  const handleEditHPISubmission = async () => {
  // if (!Doctorid) {
  //   showErrorToast("Please select a doctor");
  //   return;
  // }
  if (!editHPIData.doctorid) { // Use editHPIData.doctorid instead of Doctorid
    showErrorToast("Please select a doctor");
    return;
  }

  if (!editHPIText || editHPIText.trim() === "") {
    showErrorToast("Please enter HPI text");
    return;
  }

  const inputToSave = {
    input: {
      id: editHPIData.id, 
      appointmentid: apmtIdUrl, 
      patientid: patientid,
      updatedby: editHPIData.doctorid,
      // updatedby: Doctorid,
      updateddate: getLocalISOString(date, editHPIData.time),
      hpitext: [
        {
          "type": 'other',
          description: editHPIText,
          id: editHPIData.id,
          updatedby: editHPIData.doctorid,
          updateddate: getLocalISOString(date, editHPIData.time),
        }
      ],
      // rosname: editROSData.rosname 
    }
  };

  showLoader();
  try {
    const result = await AddHOPICall(inputToSave.input); 
    if (result.output.result === "success") {
      showSuccessToast("HPI updated successfully");
      if(apmtIdUrl) {
        fetchhistoryillnessdata(patientid, apmtIdUrl);
      } else {
        fetchhistoryillnessdata(patientid);
      }
      editHPI.current.closeModal();
    }
  } catch (error) {
    console.error("Error updating HPI:", error);
    showErrorToast("Error updating HPI");
  } finally {
    dismissLoader();
  }
};

const deleteModal = useRef();
const [deleteId, setDeleteId] = useState(null)
const openDeleteModal = (id) => {
      setDeleteId(id);
      deleteModal.current.openModal();
    };

    const handleConfirmDelete = async () => {
      if (!deleteId) return;

      const input = {
        // doctorid: doctorId,
        patientid: patientid,
        appointmentid: apmtIdUrl,
        id: deleteId,
        isactive: 0,
      //   hpitext: [{
      // }]
      };

      showLoader();
      try {
        const req = await AddHOPICall(input);
        if (req.output.result === "success") {
          if (apmtIdUrl) {
            await fetchhistoryillnessdata(patientid, apmtIdUrl);
          } else {
            await fetchhistoryillnessdata(patientid);
          }
          showSuccessToast("HPI deleted successfully.");
          deleteModal.current.closeModal();
          setDeleteId(null);
        } else {
          showErrorToast("Failed to delete HPI.");
        }
      } catch (error) {
        console.error("Error deleting HPI:", error);
        showErrorToast("Error deleting the HPI.");
      } finally {
        dismissLoader();
      }
    };

    const [doctorMasterHPIData, setDoctorMasterHPIData] = useState([]);
    const fetchHPIMasterData = async () => {
    showLoader();
    try {
      const inputData = { input: { type: "hpi" } };
      const data = await GetDoctorMasterData(inputData.input);
      const formattedData = formatHPIMasterData(data);
      setDoctorMasterHPIData(formattedData);
    } catch (error) {
      console.error("Error fetching Master HPI data:", error);
    } finally {
      dismissLoader();
    }
  };

  return (
    <>
      {isLoading && <Loader />}

      <Box w='100%' display={{ base: "none", lg: "block" }}>
        <Box>
          {apmtIdUrl && (
        <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
          <Text fontWeight='600'>History Of Present Illness</Text>
          <PrimaryButton
            fontSize="14px"
            variant="mdBtn"
            btnIcon="/assets/imgs/add.png"
            buttonText="Add HPI"
            onClick={addHPIData}
            // isDisabled={actionAccessPatients?.create ? false : true}
          />
        </Box>
          )}
      <Stepper
          orientation="vertical"
          // height="400px"
          height='calc(100vh - 160px)'
          overflow='hidden auto'
          padding='1rem'
          size="xs"
          colorScheme="#CDCFD4"
          // gap="0"
          gap="1rem"
          w="100%"
          justifyContent='flex-start'
          // orientation="vertical"
          // height="400px"
          // size="xs"
          // colorScheme="#CDCFD4"
          // gap="0"
          // w="100%"
        >
        {groupedData && groupedData.length>0 ? (

        Object.values(groupedData).map((doctor, index) => (
           <Step w="100%" flex='unset' key={index}>
           <StepIndicator color="#E6E7E9" />

           <Box flexShrink="0" w="95%">
             {/* <StepTitle fontSize="0.875rem" color="#384052" mb="0.5rem">
               {formatDate(visit.appointmentdate)}
             </StepTitle> */}
             <StepTitle as="div">
             <Box display='flex' gap='1rem'>
                 <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{doctor.updateddate ? formatDate(doctor.updateddate) : formatDate(doctor.appointmentdate)}</Text>
                 {apmtIdUrl && (
                 <Box w='fit-content'>
                    {doctor.iscurrentvisit == 1 ? (
                      <Text
                      fontSize="0.75rem"
                      borderRadius="full"
                      fontWeight="600"
                      p="0.25rem 0.5rem"
                      border="1px solid #E6E7E9"
                      // bg='#14C585'
                      // bg="#E6E7E966"
                      // color='rgb(0,151,0)'
                      bg='rgb(16, 185, 129)'
                    >
                      Current
                    </Text>
                    ) : (
                      <Text
                        fontSize="0.75rem"
                        borderRadius="full"
                        fontWeight="600"
                        p="0.25rem 0.5rem"
                        border="1px solid #E6E7E9"
                        // bg="#E6E7E966"
                        // color='rgb(255,165,0)'
                        // bg="rgb(255,165,0)"
                        // color="#E6E7E966"
                        bg="rgb(214, 158, 46)"
                      >
                        Past
                      </Text>
                    )}
                    </Box>
                 )}
                 {/* <Box w='50px' h='25px' border='1px solid #CDCFD4' borderRadius='20px' textAlign='center'>
                 <Text 
                 as='button' 
                 fontWeight='500' 
                 fontSize="0.875rem" 
                 color="#384052"
                 onClick={() => handleClick(visit.appointmentid)}
                 >View</Text>
                 </Box> */}
               </Box>
             </StepTitle>
             <StepDescription
               bg="white"
               w="100%"
               border="1px solid #E6E7E9"
               borderRadius="0.65rem"
               p="0.75rem"
             >
               <Flex justifyContent='space-between' alignItems='center'>
                 <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{doctor.doctorname} , {doctor.bookingid}</Text>
                 {/* <Image cursor='pointer' src="/assets/imgs/right-icon.png" onClick={() => handleClick(visit.appointmentid)} /> */}
                 {doctor.iscurrentvisit == 1 && (
                 <Box display="flex" gap="1.5rem" mr='1rem' cursor='pointer'>
                    <Box as="button" 
                    // disabled={actionAccessPatients?.update ? false : true}
                    // opacity={actionAccessPatients?.update ? 1 : 0.5} 
                    >
                      <Image 
                      src="/assets/svgs/edit.svg" 
                      w='1rem'
                      h='auto'
                      onClick={() => openEditHPIModal(doctor)}
                      />
                      </Box>
                      <Box as="button" 
                      // disabled={actionAccessPatients?.delete ? false : true}
                      // opacity={actionAccessPatients?.delete ? 1 : 0.5} 
                      >
                      <Image 
                      src="/assets/svgs/delete.svg"
                      w='14px'
                      h='auto'
                      onClick={() => openDeleteModal(doctor.id)}
                      />
                      </Box>
                  </Box>
                 )}
               </Flex>
               <Box
                 display="flex"
                 // justifyContent="flex-end"
                 alignItems="center"
                 p="0.5rem"
                 pl="0"
               >
                 <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{doctor.specialization}</Text>     
                 {/* <Text fontSize="0.875rem" color="#061027">
                   Visited general physician
                   Visited {visit.specality}
                 </Text> */}
               </Box>
               {/* Updated condition for details vs summary */}
          {/* {doctor.details && doctor.details.length > 0 ? (
            doctor.details.map((detail, detailIndex) => (
              detail.details ? (
                <Box bg="#F9FAFB" borderLeft="2px solid #14C585" key={`detail-${detailIndex}`} p="0.5rem">
                  <Text fontSize="0.875rem" fontWeight="500">
                    {generateDynamicText(detail)[0]}
                  </Text>
                </Box>
              ) : (
                doctor.summary && (
                  <Box bg="#F9FAFB" borderLeft="2px solid #14C585" key={`summary-${detailIndex}`} p="0.5rem">
                    <Text fontSize="0.875rem" fontWeight="500">
                      {doctor.summary}
                    </Text>
                  </Box>
                )
              )
            ))
          ) : (
            doctor.summary && (
              <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                <Text fontSize="0.875rem" fontWeight="500">
                  {doctor.summary}
                </Text>
              </Box>
            )
          )} */}

{doctor.type === "other" ? (
              <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                <Text fontSize="0.875rem" fontWeight="500">
                  {doctor.summary}
                </Text>
              </Box>
            ) : (
              doctor.details.map((detail, detailIndex) => (
                detail.details ? (
                  <Box 
                    bg="#F9FAFB" 
                    borderLeft="2px solid #14C585" 
                    key={`${doctor.bookingid}-detail-${detailIndex}`}  
                    p="0.5rem"
                  >
                    <Text fontSize="0.875rem" fontWeight="500">
                      {generateDynamicText(detail)[0]}
                    </Text>
                  </Box>
                ) : null
              ))
            )}
{/* existing */}
          {/* {doctor.type === "other" ? (
          doctor.summary && (
            <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
              <Text fontSize="0.875rem" fontWeight="500">
                {doctor.summary.split('\n').map((line, i) => (
                  // <Fragment key={i}>
                  //   {line}
                  //   <br />
                  // </Fragment>
                  <Fragment key={`${doctor.bookingid}-summary-${i}`}>
                    {line}
                    {i < doctor.summary.split('\n').length - 1 && <br />}
                  </Fragment>
                ))}
              </Text>
            </Box>
          )
        ) : (
          doctor.details.map((detail, detailIndex) => (
            detail.details ? (
              <Box bg="#F9FAFB" borderLeft="2px solid #14C585" key={`${doctor.bookingid}-detail-${detailIndex}`}  p="0.5rem">
                <Text fontSize="0.875rem" fontWeight="500">
                  {generateDynamicText(detail)[0]}
                </Text>
              </Box>
            ) : null
          ))
        )} */}
               {/* {doctor.details.map((detail, detailIndex) => (
                detail?.details &&
               <Box bg="#F9FAFB" borderLeft="2px solid #14C585" key={detailIndex} p="0.5rem">
                 <Text fontSize="0.875rem" fontWeight="500">
                   {generateDynamicText(detail)[0]}
                 </Text>
               </Box>  
               ))} */}
             </StepDescription>
           </Box>
       <StepSeparator />

         </Step>
        ))) : (
          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                            w="100%"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/svgs/coronavirus.svg"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
        
        )}
        </Stepper>
        </Box>
      </Box>

{/* Add HOPI */}
  <DynamicModal
    ref={addHPI}
    modalHeader={`Add HOPI`}
    modalWidth='600px'
    modalBody={
      <>
        {/* <Box display="flex" py="20px">  */}
        <Box display="flex"> 
          <DatePicker
            onDateChange={(selectedDateValue) =>
              handledatechange(selectedDateValue)
            }
            defaultDate={date}
            disableFutureDates={true}
            placeholderProp="Date"
            calendarStlye={{left: "-18px",  right: "unset"}}
          />
          <PrimaryInput
            variant="bothSide"
            id="vitaltime"
            inputType="time"
            inputPlace="Time"
            pr="10px"
            defaultValue={time}
            inputValue={time}
            onChange={handleTimeChange }
          />
        </Box>
        <Box display="flex" flexDir="column">
          <DropdownInput
            variant="bothSide"
            dropDownPlace="Doctor Name*"
            options={DoctorListForDropdown?DoctorListForDropdown:""}
            id="Doctor Name"
            onClick={HandleAddDoctor}
            value={DefaultDoctor} 
            defaultOption={DefaultDoctor}
            menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
            inputStyleCss={{ w: "100%" }}
          />
        </Box>

        {/* <HpiNotesCard
          patientId={patientid}
          doctorId={getLoginID()}
          appointmentId={apmtIdUrl}
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          // fetchDoctorNotesEmptyIndication={
          //   fetchDoctorNotesEmptyIndication
          // }
          // submitOnTabSwitch={submitHPITab}
        /> */}

        <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
          {/* <Accordion
                    allowMultiple
                    index={expandedIndices}
                    onChange={(indices) => setExpandedIndices(indices)}
                  >
                    {doctorMasterHPIData.map((item) => (
                      <AccordionItem key={item.type}>
                        <h2>
                          <AccordionButton>
                            <Box flex="1" fontSize='14px' textAlign="left">
                              {item.type.toUpperCase()}
                            </Box>
                            <Badge
                              ml="1"
                              color="blue"
                              bg="white"
                              cursor="pointer"
                              onClick={(event) => handleAddHPI(event, item.type)}
                            >
                              + Add
                            </Badge>
                            <AccordionIcon />
                          </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4} bg="#f9fafb">
                          {doctorNotesHPIData
                            .filter(
                              (note) =>
                                note.type.toLowerCase() === item.type.toLowerCase()
                            )
                            .map((note) => {
                              // Extract all other options that are not part of the explicitly handled attributes
                              const otherOptions = note.details.reduce((acc, detail) => {
                                if (
                                  ![
                                    "Site",
                                    "Onset",
                                    "Chronicity",
                                    "Onset Quality",
                                    "Frequency",
                                    "Rating Scale",
                                    "Associated Symptoms",
                                    "Time",
                                    "Time Value",
                                  ].includes(detail.attribute)
                                ) {
                                  acc[detail.attribute] = detail.values?.map(
                                    (v) => v.value
                                  ) || [detail.value];
                                }
                                return acc;
                              }, {});
          
                              return (
                                <Box p={{ base: "2", md: "4" }} key={note.id}>
                                  <HPIViewCard
                                    id={note.id}
                                    site={
                                      note.details
                                        .find((detail) => detail.attribute === "Site")
                                        ?.values.map((v) => v.value) || []
                                    }
                                    onset={
                                      note.details.find(
                                        (detail) => detail.attribute === "Onset"
                                      )?.value || ""
                                    }
                                    chronicity={
                                      note.details.find(
                                        (detail) => detail.attribute === "Chronicity"
                                      )?.value || ""
                                    }
                                    onsetQuality={
                                      note.details.find(
                                        (detail) => detail.attribute === "Onset Quality"
                                      )?.value || ""
                                    }
                                    frequency={
                                      note.details.find(
                                        (detail) => detail.attribute === "Frequency"
                                      )?.value || ""
                                    }
                                    ratingScale={
                                      note.details.find(
                                        (detail) => detail.attribute === "Rating Scale"
                                      )?.value || ""
                                    }
                                    associatedSymptoms={
                                      note.details
                                        .find(
                                          (detail) =>
                                            detail.attribute === "Associated Symptoms"
                                        )
                                        ?.values.map((v) => v.value) || []
                                    }
                                    time={
                                      note.details.find(
                                        (detail) => detail.attribute === "Time"
                                      )?.value || ""
                                    }
                                    timeValue={
                                      note.details.find(
                                        (detail) => detail.attribute === "Time Value"
                                      )?.value || ""
                                    }
                                    deleteHPI={() => openDeleteModal(note.id)}
                                    editHPI={() => editHPI(note)}
                                    otherOptions={otherOptions} // Pass the dynamically extracted options here
                                  />
                                </Box>
                              );
                            })}
                        </AccordionPanel>
                      </AccordionItem>
                    ))}
                  </Accordion> */}
          <Box
            as="form"
            width='100%'
            bg="white"
            pt={"2px"}
          >
            <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
              <Textarea
                borderRadius='0'
                // placeholder="Instructions"
                {...register("textField")}
                // inputValue={addHPIText}
                value={addHPIText}
                onChange={handleTextChange}
                height="100%"
                padding="2"
                resize="none"
                // disabled={typing} // Disable when AI typing is true
                style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
              />
              
              {!addHPIText && (
                <Text
                  position="absolute"
                  bottom="2"
                  left="50%"
                  transform="translateX(-50%)"
                  fontSize="sm"
                  color="gray.500"
                  w={{ base: "100%", md: "unset" }}
                  textAlign={{ base: "center", md: "unset" }}
                >
                  {placeholder}
                </Text>
              )}
            </Box>
          </Box>
        </Box>
      </>
    }
    modalFooterBtn={
      <>
      <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                />
            <Box
              as="button"
              type="button" // Prevent form submission
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("add")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>
        <PrimaryButton
          // variant="deleteBtn"
          buttonText="Add HPI"
          btnStyle={{
            w: "100%",
            h: "2.5rem",
          }}
          onClick={() => {
            handleHPISubmission();
          }}
        />
      </>
    }
  />

{/* Edit HOPI */}
  <DynamicModal
    ref={editHPI}
    modalHeader={`Edit HOPI`}
    modalWidth='600px'
    modalBody={
      <>
        {/* <Box display="flex" py="20px">  */}
        <Box display="flex"> 
          <DatePicker
            onDateChange={(selectedDateValue) =>
              handledatechange(selectedDateValue)
            }
            defaultDate={editHPIData.date}
            disableFutureDates={true}
            placeholderProp="Date"
            calendarStlye={{left: "-18px",  right: "unset"}}
          />
          <PrimaryInput
            variant="bothSide"
            id="vitaltime"
            inputType="time"
            inputPlace="Time"
            pr="10px"
            defaultValue={editHPIData.time}
            inputValue={editHPIData.time}
            onChange={handleEditTimeChange }
          />
        </Box>
        <Box display="flex" flexDir="column">
          <DropdownInput
            variant="bothSide"
            dropDownPlace="Doctor Name*"
            options={DoctorListForDropdown?DoctorListForDropdown:""}
            id="Doctor Name"
            onClick={HandleEditDoctor}
            // value={DefaultDoctor} 
            // defaultOption={DefaultDoctor}
            value={editHPIData.doctorname} 
          defaultOption={editHPIData.doctorname}
            menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
            inputStyleCss={{ w: "100%" }}
          />
        </Box>

        <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
          <Box
            as="form"
            width='100%'
            bg="white"
            pt={"2px"}
          >
            <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
              <Textarea
                borderRadius='0'
                // placeholder="Instructions"
                {...register("textField")}
                inputValue={editHPIText}
                // value={updateCC}
                onChange={handleEditTextChange}
                height="100%"
                padding="2"
                resize="none"
                // disabled={typing} // Disable when AI typing is true
                style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
              />
              
              {!editHPIText && (
                <Text
                  position="absolute"
                  bottom="2"
                  left="50%"
                  transform="translateX(-50%)"
                  fontSize="sm"
                  color="gray.500"
                  w={{ base: "100%", md: "unset" }}
                  textAlign={{ base: "center", md: "unset" }}
                >
                  {placeholder}
                </Text>
              )}
            </Box>
          </Box>
        </Box>
      </>
    }
    modalFooterBtn={
      <>
      <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                />
            <Box
              as="button"
              type="button" // Prevent form submission
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("edit")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>
        <PrimaryButton
          // variant="deleteBtn"
          buttonText="Edit HPI"
          btnStyle={{
            w: "100%",
            h: "2.5rem",
          }}
          onClick={() => {
            handleEditHPISubmission();
          }}
        />
      </>
    }
  />

{/* Delete ROS */}
<DynamicModal
          ref={deleteModal}
          modalHeader="Delete HPI?"
          modalBody={
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete this HPI?
            </Text>
          }
          modalFooterBtn={
            <PrimaryButton
              buttonText="Delete"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={handleConfirmDelete}
            />
          }
        />

      {/* Mobile responsive */}
      <Box w="100%" display={{ base: "block", lg: "none" }}>
        <MobileSecondaryNav header="HPI" handlebackarrow={backFunction} />
        <Box h="calc(100vh - 120px)" overflow="hidden auto" p="1rem">
        <Stepper
          orientation="vertical"
          height="400px"
          size="xs"
          colorScheme="#CDCFD4"
          gap="0"
          w="100%"
        >
        {Object.values(groupedData).map((doctor, index) => (
           <Step w="100%" pb="1rem" key={index}>
           <StepIndicator color="#E6E7E9" />

           <Box flexShrink="0" w="95%">
             {/* <StepTitle fontSize="0.875rem" color="#384052" mb="0.5rem">
               {formatDate(visit.appointmentdate)}
             </StepTitle> */}
             <StepTitle as="div">
             <Box display='flex' gap='1rem'>
                 <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(doctor.appointmentdate)}</Text>
                 {/* <Box w='50px' h='25px' border='1px solid #CDCFD4' borderRadius='20px' textAlign='center'>
                 <Text 
                 as='button' 
                 fontWeight='500' 
                 fontSize="0.875rem" 
                 color="#384052"
                 onClick={() => handleClick(visit.appointmentid)}
                 >View</Text>
                 </Box> */}
               </Box>
             </StepTitle>
             <StepDescription
               bg="white"
               w="100%"
               border="1px solid #E6E7E9"
               borderRadius="0.65rem"
               p="0.75rem"
             >
               <Flex justifyContent='space-between' alignItems='center'>
                 <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{doctor.doctorname} , {doctor.bookingid}</Text>
                 {/* <Image cursor='pointer' src="/assets/imgs/right-icon.png" onClick={() => handleClick(visit.appointmentid)} /> */}
               </Flex>
               <Box
                 display="flex"
                 // justifyContent="flex-end"
                 alignItems="center"
                 p="0.5rem"
                 pl="0"
               >
                 <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{doctor.specialization}</Text>     
                 {/* <Text fontSize="0.875rem" color="#061027">
                   Visited general physician
                   Visited {visit.specality}
                 </Text> */}
               </Box>
               {doctor.details.map((detail, detailIndex) => (
                  detail?.details &&
               <Box bg="#F9FAFB" borderLeft="2px solid #14C585" key={detailIndex} p="0.5rem">
                 <Text fontSize="0.875rem" fontWeight="500">
                   {/* Reason: Headache, stomach ache, coughing and vomiting */}
                   {generateDynamicText(detail)[0]}
                 </Text>
               </Box>
               ))}
               {/* <Box display="flex" p="0.5rem" pl="0" alignItems="center">
                 <Image w="0.75rem" h="auto" src="/assets/svgs/update.svg" />
                 <Text
                   fontSize="0.875rem"
                   fontWeight="500"
                   color="#6A707D"
                   pl="0.5rem"
                 >
                   Reason: Headache, stomach ache, coughing and vomiting
                   {''}
                 </Text>
               </Box> */}
             </StepDescription>
           </Box>
       <StepSeparator />

         </Step>
        ))}
        </Stepper>
        </Box>
      </Box>
    </>
  );
};

export default HistoryOfPresentIllness;
